import { useRouter } from 'next/router'
import { useCallback } from 'react'

export const useRemoveQueryParam = () => {
  const router = useRouter()

  const removeQueryParam = useCallback(
    (param: string) => {
      const { [param]: _, ...otherQueryParams } = router.query
      router.push(
        {
          query: otherQueryParams,
        },
        undefined,
        { shallow: true }
      )
    },
    [router]
  )

  return { removeQueryParam }
}
